import axios from 'axios';

// Get API URL - check if we're in production
const getApiBaseUrl = () => {
  // In production, use the current origin + /api
  if (process.env.NODE_ENV === 'production') {
    return `${window.location.origin}/api`;
  }
  // Use environment variable if set, otherwise default to localhost
  return process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
};

const API_BASE_URL = getApiBaseUrl();

console.log('API Base URL:', API_BASE_URL);
console.log('Environment:', process.env.NODE_ENV);
console.log('REACT_APP_API_URL:', process.env.REACT_APP_API_URL);

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000, // 30 seconds timeout for mobile networks
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle auth errors and network errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle authentication errors
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
      return Promise.reject(error);
    }
    
    // Handle server errors (500, 502, 503) - redirect to schools page
    if (error.response?.status >= 500) {
      const friendlyMessage = 'We encountered a server error. Please try again in a few moments.';
      setTimeout(() => {
        if (window.location.pathname !== '/schools') {
          window.location.href = '/schools';
        }
      }, 3000);
      error.userFriendlyMessage = friendlyMessage;
    }
    
    // Handle network errors (no response for mobile)
    if (!error.response) {
      // Network error - no response from server
      if (error.code === 'ECONNABORTED') {
        error.userFriendlyMessage = 'Request timeout. Please check your internet connection and try again.';
      } else if (error.message === 'Network Error') {
        error.userFriendlyMessage = 'Unable to connect to server. Please check your internet connection.';
      } else {
        error.userFriendlyMessage = 'Network error. Please check your internet connection and try again.';
      }
      error.isNetworkError = true;
      
      // Redirect to schools page on network errors after showing message
      setTimeout(() => {
        if (window.location.pathname !== '/schools') {
          window.location.href = '/schools';
        }
      }, 3000);
    }
    
    return Promise.reject(error);
  }
);

export default api;

